<app-header
  icon="fas fa-scale-unbalanced-flip"
  text="Vergleichswerte"
  sub="Benennen Sie hier Vergleichs- oder Sonderwerte zur Darstellung in Diagrammen und Tabellen."></app-header>
<p-divider />

@if (store.asArray(); as comparisonValues) {
  <p-table
    #comparisonValueTable
    [globalFilterFields]="['name', 'key']"
    [value]="comparisonValues">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(comparisonValueTable)"
        (search)="
          comparisonValueTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Schlüssel</th>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td>
          <span class="flex align-items-center gap-3"
            ><i class="w-1rem text-center fas fa-scale-unbalanced-flip"></i>
            {{ value.key }}</span
          >
        </td>
        <td>
          {{ value.name }}
        </td>
        <td>
          @if (value.key !== 'avg' && value.key !== 'total') {
            <app-table-list-actions
              [item]="value"
              (confirm)="confirm($event, value, value.name)">
            </app-table-list-actions>
          } @else {
            <i class="text-color-secondary">vorgegeben</i>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine Farbsets gefunden</span>
    </div>
  </div>
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-5'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
